import React, {Component} from 'react';
import {Row, Col, Progress, Card, Modal, ModalBody, CardTitle, CardHeader, CardBody, Button, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, Alert} from 'reactstrap';
import { ajaxWrapperGet,ajaxWrapperGetQuery } from '../../../utils/deviceAPI';

import LoadingIndicator from '../../../utils/LoadingIndicator';
import {Bar, Line, ChartData} from "react-chartjs-2";

import Generator from '../GeneratorSchema/Generator'
import moment from 'moment'
import DeviceOffline from '../DeviceMessages/DeviceOffline';
import Error from '../DeviceMessages/Error';
//daterange
import 'react-dates/initialize';
import { DateRangePicker, isInclusivelyAfterDay, isSame } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import '../../Forms/AdvancedForms/react_dates_overrides.css';




const AlarmListPender = (props) =>  {
    let items = {
        "warning" : "exclamation",
        "danger" : "times",
        "success" : "check",
        "info" : "commenting-o"
    };
    const listItems = props.items.map((alarm,index) => {
            return (
                <li key={index} className="mb-2 mt-2">
                    <i className={"fa fa-" + items[alarm.type] + " bg-" + alarm.type}></i>
                    <div className="desc">
                        <div className="title">{alarm.description}</div>
                        <div className="small text-muted text-uppercase pb-3">{alarm.name}</div>
                    </div>
                </li>
            );
        }
    );
    return (
        <div>
            {listItems}
        </div>
    );
};



class AlarmsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [
            {
                initializer: 0,
            },
            {
                initializer: 0,
            }

        ],
            bitWordData: [],
            loading: true,
            modalAlarmPointSplit: false

        };
        this.toggleModalAlarmPointSplit = this.toggleModalAlarmPointSplit.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: false
        });
    }
    getBitAlarmData(alarmID = 0, device = "", alarmValue = 0) {
        let query = `&id=${alarmID}&almval=${alarmValue}`;
        ajaxWrapperGetQuery('/api/deviceAlarmHistoryBitData',device,query).then((bitWordData) => {
            this.setState({
                bitWordData,
                loading: false
            });
            this.toggleModalAlarmPointSplit();

        });
    }
    toggleModalAlarmPointSplit() {
        this.setState({
            modalAlarmPointSplit: !this.state.modalAlarmPointSplit
        });
    }
    render() {

        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        return (
            <Row className="mb-5">
                <Col xs="12">
                    <Table className="animated fadeIn" responsive>
                        <thead>
                        <tr>
                            <th>Alarm</th>
                            <th>Date</th>
                            <th>State</th>
                            <th>Notification</th>
                            <th> </th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.items.length === 0 ?
                            <tr>
                                <td colSpan="5">
                                    <Alert color="secondary" >
                                        <small>No Data Available. Please select a valid start to end date.</small>
                                    </Alert>
                                </td>
                            </tr>
                            :
                            this.props.items.map((alarmhistory,index) => {
                                return (
                                    <tr key={index}>
                                        <td><div className="text-muted text-uppercase font-sm">{alarmhistory.alarmDesc}</div></td>
                                        <td><div className="text-muted text-uppercase font-sm">{moment(alarmhistory.alarmTriggerd).format('MM/DD/YY - hh:mm:ss A') }</div></td>
                                        <td>{alarmhistory.alarmState ? <Alert color="danger" className="mb-0 pr-1 pt-1 pb-1 pl-3">Active</Alert>: <Alert color="secondary" className="mb-0 pr-1 pt-1 pb-1 pl-3">Inactive</Alert>}</td>
                                        <td>{alarmhistory.smsNotifiedReason === 1 ? <Alert color="success" className="mb-0 pr-1 pt-1 pb-1 pl-3"><i className="fa fa-check text-success"></i> Notification Sent</Alert> : alarmhistory.smsNotifiedReason === 2 ? <Alert color="danger" className="mb-0 pr-1 pt-1 pb-1 pl-3"><i className="fa fa-ban text-danger"></i> Recent Occurrence</Alert> : ""}</td>
                                        <td className="text-right">
                                            {(alarmhistory.alarmValue >= 1) && (alarmhistory.unpackBits === 1) ? <Button outline color="secondary" className="btn btn-sm mr-2" onClick={() => {this.getBitAlarmData(alarmhistory.alarmID, alarmhistory.deviceName, alarmhistory.alarmValue)}}><i className="fa fa-list-ol"> </i></Button>:""}
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </Table>
                    <Modal isOpen={this.state.modalAlarmPointSplit} toggle={this.toggleModalAlarmPointSplit} >

                        <ModalBody>
                            <Row>
                                <Col sm="10">
                                    <CardTitle className="mb-1">List Alarm</CardTitle>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <hr className="mb-4"/>
                                </Col>
                            </Row>
                            <Row className="pb-2">
                                <Col sm="12">
                                    <ul className="icons-list mb-5 list-inline">
                                        <AlarmListPender items={this.state.bitWordData} />
                                    </ul>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    <hr className="mb-4"/>
                                </Col>
                            </Row>
                            <Row className="pb-4">
                                <Col sm="6" className="small text-muted">
                                </Col>
                                <Col sm="6" className="small text-muted">
                                    <Button color="secondary" className="btn btn-block" onClick={this.toggleModalAlarmPointSplit}>Close</Button>
                                </Col>
                            </Row>
                        </ModalBody>
                    </Modal>
                </Col>
            </Row>
        )
    }
}

export default AlarmsList;



// WEBPACK FOOTER //
// ./src/views/site/Alarms/AlarmsList.js